<!--  -->
<template>
  <div>
    <div class="notesbfa" id="tip2" style="border: none" v-show="$store.state.isLogin">
      <div class="faxbox">
        <div class="clearfix">
          <h4 class="userleaving">
            用户留言：
            <textarea id="remark" maxlength="200" v-model="notes"></textarea>
          </h4>
        </div>
      </div>
    </div>
    <div class="Receaddress" id="tip3">
      <div class="invoice_sendwithgift">
        <span id="sec_count"><b>已选文献：</b>{{ totalPiece }}篇</span>
        <span id="sec_discount" v-show="false"><b>已优惠：</b>￥{{ totalDiscountV }}</span>
        <span id="total_money"><b>总计：</b>￥{{ totalBalance }}</span>
        <a @click="submit()" class="btn-1 js_btn_1" href="javascript:;" :style="$store.state.isLogin?'':'background-color: #b9b4b1;'">提交申请 </a>
        <!-- <a href="/" class="btn-2">取消</a> -->
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Pubsub from 'pubsub-js'
export default {
  props: ['totalBalance', 'totalPiece','totalDiscountV'],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      notes: '',
      submitBg:'background-color: #b9b4b1;',
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    notes: function () {
      this.$emit('notes', this.notes)
    }

  },
  //方法集合
  methods: {
    submit() {
      if (!this.$store.state.isLogin) {
        this.$emit('loginDialog')
      } else {
        Pubsub.publish('submitOrder',"balance")
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.$store.state.isLogin) {
      this.submitBg=''
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/cart/Balance.vue